import React, {useEffect, useMemo, useRef, useState} from "react";
import {useLoader} from "@react-three/fiber";
import {STLLoader} from "three/addons/loaders/STLLoader";
import {connect} from "react-redux";
import action from "../../../store/action";
import * as THREE from 'three'
import {DRACOLoader} from "three/examples/jsm/loaders/DRACOLoader";



/**
 * @description create gum function. In order to batch creation gum
 * @param props The parameter passed by the attribute within the tag
 * */
const BiteStop = React.memo(function Attachment(props) {
    const {biteStopCheckboxValue, opacity, url, fileType} = props


    const ref = useRef()

    //load model
    let loader = STLLoader

    if(fileType === 'drc') {
        loader = DRACOLoader
    }

    let model = useLoader(loader, url, loaderInstance=> {

        if(loaderInstance instanceof DRACOLoader) {

            loaderInstance.setDecoderPath('/draco/');
            loaderInstance.setDecoderConfig({ type: 'js' });
        }

    })

    return (
        <mesh
            {...props}
            ref={ref}
            geometry={model}
            // matrix={toothMatrix}
            // matrixAutoUpdate={false}
            renderOrder={1}
            visible={biteStopCheckboxValue}
        >
            <meshStandardMaterial
                color={'#4E9DC6'}
                transparent={true}
                opacity={opacity}
                depthWrite={opacity > 0.5 ? true : false}
                depthTest={true}
                roughness={0.4}
                metalness={0}
                reflectivity={0.3}
                emissive={'#fff'}
                emissiveIntensity={0.05}
            />

        </mesh>
    )
})

const mapStateToProps = state => ({
    biteStopCheckboxValue: state.webViewer.biteStopCheckboxValue
})

const mapDispatchToProps = dispatch => ({
})


export default connect(mapStateToProps, mapDispatchToProps)(BiteStop)
